import { DESKTOP_BREAKPOINT } from "../utils/constants.mjs";

document.addEventListener("DOMContentLoaded", function () {
  // Navbar
  let currentSubnav = null;
  const activeListeners = [];

  function addListener(element, type, handler, options) {
    if (!element) return;
    element.addEventListener(type, handler, options);
    activeListeners.push({ element, type, handler, options });
  }

  function addListenerAll(elements, type, handler, options) {
    elements.forEach(function (el) { addListener(el, type, handler, options); });
  }

  function removeAllListeners() {
    activeListeners.forEach(function (item) {
      item.element.removeEventListener(item.type, item.handler, item.options);
    });
    activeListeners.length = 0;
  }

  function removeClasses(selector, className) {
    document.querySelectorAll(selector).forEach(function (el) { el.classList.remove(className); });
  }

  function closeSubnavs() {
    removeClasses(".navbar-link", "active");
    removeClasses(".subnav", "showing");
  }

  function setupMobileNavbar() {
    // Mobile: show submenus on click
    const navbarLinks = Array.from(document.querySelectorAll(".navbar-link[show-subnav]"));
    addListenerAll(navbarLinks, "click", function (event) {
      const link = event.currentTarget;

      if (link.classList.contains("active")) {
        link.classList.remove("active");
        removeClasses(".subnav", "showing"); // hide all submenus
        return;
      }

      removeClasses(".navbar-link", "active");
      link.classList.add("active");
      removeClasses(".subnav", "showing"); // hide all submenus
      removeClasses(".subnav", "initial-cloak"); // Optimize page load (CTA)
      var subnavId = link.getAttribute("show-subnav");
      const subnav = document.getElementById(subnavId);
      if (subnav) subnav.classList.add("showing");
      currentSubnav = subnavId;
    });

    // Hide subnavs when clicking outside
    addListener(document, "click", function (event) {
      const target = event.target;
      if (target.closest('.subnav')) return;
      if (target.closest('.navbar-link')) return;

      removeClasses(".navbar-link", "active");
      removeClasses(".subnav", "showing");
    });

    // Back buttons inside subnav
    const backButtons = Array.from(document.querySelectorAll(".subnav .back"));
    addListenerAll(backButtons, "click", closeSubnavs);

    // Adjust padding for iOS toolbar
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      const toolbarHeight = 65;
      document.querySelectorAll(".navbar-menu, .subnav-container").forEach(function (el) {
        el.style.paddingBottom = toolbarHeight + "px";
      });
    }
  }

  function setupDesktopNavbar() {
    const links = Array.from(document.querySelectorAll(".navbar-link[show-subnav]"));
    addListenerAll(links, "mouseenter", function (event) {
      removeClasses(".subnav", "showing");
      var subnavId = event.currentTarget.getAttribute("show-subnav");
      const subnav = document.getElementById(subnavId);
      if (subnav) subnav.classList.add("showing");
      currentSubnav = subnavId;
    });
    addListenerAll(links, "mouseleave", function (event) {
      var subnavId = event.currentTarget.getAttribute("show-subnav");
      const subnav = document.getElementById(subnavId);
      if (subnav) subnav.classList.remove("showing");
    });

    const subnavs = Array.from(document.querySelectorAll(".subnav"));
    addListenerAll(subnavs, "mouseenter", function () {
      if (currentSubnav != null) {
        const subnav = document.getElementById(currentSubnav);
        if (subnav) subnav.classList.add("showing");
      }
    });
    addListenerAll(subnavs, "mouseleave", function (event) {
      currentSubnav = null;
      event.currentTarget.classList.remove("showing");
    });
  }

  function setupNavbar() {
    // Clear iOS toolbar padding on every setup so it doesn't persist across resize
    document.querySelectorAll(".navbar-menu, .subnav-container").forEach(function (el) {
      el.style.paddingBottom = "";
    });

    // Hide submenu if user scrolls down
    addListener(window, "scroll", function () {
      if (window.innerWidth > DESKTOP_BREAKPOINT && window.scrollY > 40) {
        document.querySelectorAll(".navbar-menu .navbar-link.active").forEach(function (el) {
          el.classList.remove("active");
        });
        document.querySelectorAll("section.subnav.showing").forEach(function (el) {
          el.classList.remove("showing");
        });
      }
    });

    // const mobileMenu = window.innerWidth < DESKTOP_BREAKPOINT;  // calling window.innerWidth is expensive
    // if (mobileMenu) {
    //   setupMobileNavbar();
    // } else {
    //   // setupDesktopNavbar();
    //   setupMobileNavbar();  // For now, we'll try the same behavior on desktop
    // }
    setupMobileNavbar();
  }

  setupNavbar();

  // Throttled resize
  addListener(window, "resize", function () {
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function () {
      removeAllListeners();
      setupNavbar();
    }, 250);
  });

  // One-time hover on navbar-wrapper to uncloak
  const navbarWrapper = document.querySelector(".navbar-wrapper");
  function handleNavbarWrapperEnter() {
    removeClasses(".subnav", "initial-cloak");
    if (navbarWrapper) navbarWrapper.removeEventListener("mouseenter", handleNavbarWrapperEnter);
  }
  if (navbarWrapper) {
    addListener(navbarWrapper, "mouseenter", handleNavbarWrapperEnter);
  }

  // El toggle del burger menu ahora se maneja completamente con Alpine.js
  // a través de @click="showMobileMenu = !showMobileMenu" y :class="{'is-active': showMobileMenu}"
  // en el template navbar.html. No necesitamos JavaScript vanilla aquí.
});

// Scroll progress bar
(function () {
  const bar = document.getElementById("scroll-progress-bar");
  if (!bar) return;
  function updateProgress() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    bar.style.width = pct + "%";
    bar.setAttribute("aria-valuenow", Math.round(pct));
  }
  window.addEventListener("scroll", updateProgress, { passive: true });
  updateProgress();
})();

const userContinent = Intl.DateTimeFormat().resolvedOptions().timeZone.split('/')[0].toLowerCase();
const isStaff = JSON.parse(document.getElementById('is-staff-user').textContent);
const destinationsListEurope = JSON.parse(document.getElementById('destinations-list-europe').textContent);

// Only show destinations from DESTINATIONS_LIST_EUROPE for europeans if not an admin
if (userContinent === 'europe' && !isStaff) {
  let subnavEurope = document.querySelector("#subnav-europa div.columns");
  const destinationElements = destinationsListEurope.map(slug => document.querySelector(`#subnav-${slug}`));
  try {
    subnavEurope.querySelectorAll(".countries-column").forEach(el => el.remove());
  } catch (e) {
    console.error("Error removing countries-column elements:", e);
  }

  const nullElements = destinationElements.filter(el => el == null);
  if (nullElements.length > 0) {
    console.error(`Error adding subnav elements, some destinations are null: ${destinationsListEurope.join(', ')}`);
  }

  const destinationsHTML = destinationElements
    .filter(el => el != null)
    .map(el => el.outerHTML)
    .join('');

  let columns = `
    <div class="column countries-column">
      <ul>
        ${destinationsHTML}
      </ul>
    </div>
    <div class="column countries-column"></div>
    <div class="column countries-column is-hidden-touch"></div>
  `
  let htmlObject = document.createElement('div')
  htmlObject.innerHTML = columns;
  subnavEurope.querySelector(".otros").innerHTML = ""
  subnavEurope.querySelector(".otros").insertAdjacentHTML('beforebegin', columns);

  // Remove on desktop subnav
  subnavEurope.querySelector("ul.is-hidden-touch").remove();

  // Remove from the footer
  document.getElementById("footer-europa-anchor").remove();
}
